import {
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText,
  useWSModalCustom
} from "@wingspanhq/fe-component-library";
import { PersonMfaFactor } from "@wingspanhq/wingspan-api-sdk";
import { ErrorAlert } from "@components/ErrorAlert";
import { queriesMfa } from "@query";
import React from "react";
import { mfaFactorTypeName } from "./mfaFactorEnroll";

type Props = {
  factor: PersonMfaFactor;
} & WSModalCustomProps<boolean>;

const ModalRemoveMfaFactor: React.FC<Props> = props => {
  const [deleteFactor, deleteMeta] = queriesMfa.deleteMfaFactor.useMutation();

  const handleRemove = async () => {
    await deleteFactor(
      { mfaFactorId: props.factor.id },
      { onSuccess: () => props.onClose(true) }
    );
  };

  return (
    <WSModal
      title="Remove verification method?"
      size="S"
      onClose={() => props.onClose(false)}
      actions={{
        buttons: [
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: () => props.onClose(false)
          },
          {
            kind: "Primary",
            destructive: true,
            label: "Remove",
            loading: deleteMeta.isLoading,
            onClick: handleRemove
          }
        ]
      }}
    >
      <WSList gap="M">
        <WSText>
          {mfaFactorTypeName(props.factor.type)} ({props.factor.label}) will no
          longer be available for verifying it's you. You can add it again at
          any time.
        </WSText>
        <ErrorAlert error={deleteMeta.error} context="MfaFactor" />
      </WSList>
    </WSModal>
  );
};

export const useModalRemoveMfaFactor = () =>
  useWSModalCustom(ModalRemoveMfaFactor);
